import React from 'react';
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {LuLayoutDashboard} from "react-icons/lu";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import {MdEditSquare} from "react-icons/md";
import API from "../../Services/API";
import {FaEye} from "react-icons/fa";
import {useNavigate} from "react-router-dom";
import Loading from "../../Layouts/Loading";
import { saveAs } from 'file-saver';

function ProductTracking() {
    const navigate = useNavigate();

    const [documentFile, setDocumentFile] = React.useState(null);
    const [products, setProducts] = React.useState([]);
    const [isLoaded, setIsLoaded] = React.useState(true);

    const onDocChange = (event) => {
        setDocumentFile(event.target.files[0])
    }
    const onUploadClick = (excel = 0) => {
        const formData = new FormData();
        const file = documentFile;

        if (file) {
            if(file.size > 2485760) {
                toast.error('حجم فایل ارسالی نمی تواند بیشتر از 2 مگابایت باشد');
                return false;
            }
            formData.append('excel_file', file);

        } else {
            toast.error('لطفا ابتدا یک فایل معتبر انتخاب کنید!');
            return false;
        }

        formData.append('excel', excel);
        setIsLoaded(false)

        API.uploadTracking(formData,excel)
            .then((response) => {

                setIsLoaded(true)
                toast.success(response.message)


            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setIsLoaded(true)
            });
    }
    return (
        <React.Fragment>
            <Header/>
            {
                !isLoaded && <Loading/>
            }
            <Navbar page="tracking"/>
            <Toast/>
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <LuLayoutDashboard className='ms-2' />
                        بارگزاری کد رهگیری کالا
                    </h1>

                </div>

                <section className="section dashboard">
                    <div className="row rtl">
                        <div className="col--12">

                            <div className="card info-card customers-card">


                                <div className="card-body">


                                    <div className="d-flex align-items-center">
                                        <p className='p-2 mt-4 fw-bold text-muted border-bottom pb-3 w-100'>
                                            <MdEditSquare className='mx-2 text-success text-big-3'/>
                                        برای  بارگزاری کد رهگیری کالا های مورد نظر، فایل اکسل حاوی کدهای محصولات را بارگزاری کرده و دکمه   بارگزاری را بزنید
                                            <a href="https://api.ngkh.ir/storage/app/media/tracking.xlsx" target="_blank"
                                               className='mx-3 text-decoration-underline' rel="noreferrer">
                                                دانلود فایل اکسل نمونه
                                            </a>
                                        </p>


                                    </div>
                                    <div className="row">
                                        <div className="col-md-3  ">
                                            <label className="custom-file-upload">
                                                انتخاب فایل اکسل
                                                <input type="file" onChange={onDocChange}
                                                       accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                                />
                                            </label>

                                            <div
                                                className=" text-success text-small-2  bg-light mt-2 p-1 text-center">
                                                &nbsp;
                                                {
                                                    documentFile ?
                                                        " فایل انتخاب شده : " +
                                                        documentFile.name
                                                        : ''
                                                }
                                            </div>
                                        </div>

                                        <div className="col-md-9 text-start mt-3">
                                            <button className="btn btn-primary  w-50"
                                                    onClick={() => {onUploadClick(0)}}>
بارگزاری

                                            </button>
                                        </div>


                                    </div>
                                </div>
                            </div>

                        </div>

                        {
                            products.length > 0 &&

                            <div className="col-12">
                                <div className="card info-card sales-card">
                                    <div className="card-body rtl pt-5 table-responsive">


                                        <table className="table table-striped  ">
                                            <thead>
                                            <tr className='text-small-2 text-muted'>
                                                <th scope="col" className='bg-success-subtle rounded-end-3'>#</th>
                                                <th scope="col" className='bg-success-subtle'>کد</th>
                                                <th scope="col" className='bg-success-subtle'>برند</th>
                                                <th scope="col" className='bg-success-subtle'>آمپراژ</th>
                                                <th scope="col" className='bg-success-subtle'>نماینده</th>
                                                <th scope="col" className='bg-success-subtle'>شروع گارانتی</th>
                                                <th scope="col" className='bg-success-subtle'>پایان گارانتی</th>
                                                <th scope="col" className='bg-success-subtle'>مانده گارانتی</th>
                                                <th scope="col" className='bg-success-subtle'>وضعیت </th>
                                                <th scope="col" className='bg-success-subtle'>آخرین ویرایش </th>
                                                <th scope="col" className='bg-success-subtle'> سریال جایگزین </th>
                                                <th scope="col" className='bg-success-subtle'> آمپر جایگزین </th>
                                                <th scope="col" className='bg-success-subtle'> شماره محموله </th>
                                                <th scope="col" className='bg-success-subtle'> تاریخ محموله </th>
                                                <th scope="col" className='bg-success-subtle'> مشتری  </th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                products?.map((product, index) => {
                                                    return (
                                                        <tr key={product.id}
                                                            role='button'
                                                        >
                                                            <th scope="row">
                                                                {(index + 1)}
                                                            </th>
                                                            <td>
                                                                {product.code}

                                                            </td>
                                                            <td>
                                                                {product.brand}

                                                            </td>
                                                            <td>
                                                                {product.amperage}
                                                            </td>
                                                            <td>
                                                                {product.vendor}
                                                            </td>
                                                            <td>
                                                                {product.warranty_start_date}
                                                            </td>
                                                            <td>
                                                                {product.warranty_end_date}
                                                            </td>
                                                            <td>
                                                                {product.remaining}
                                                            </td>
                                                            <td>
                                                                {product.last_status}
                                                            </td>
                                                            <td>
                                                                {product.last_status_date}
                                                            </td>
                                                            <td>
                                                                {product.alternate_code}
                                                            </td>
                                                            <td>
                                                                {product.alternate_amperage}
                                                            </td>
                                                            <td role='button'
                                                                onClick={
                                                                    () => {
                                                                        navigate(`/orders/${product?.order_id}`)
                                                                    }
                                                                }
                                                            >
                                                                {product.order_factor_number}
                                                                {product.order_factor_number  &&
                                                                <FaEye
                                                                    className='mx-2 text-big-2 text-primary'/>
                                                                }
                                                            </td>
                                                            <td>
                                                                {product.order_date}
                                                            </td>
                                                            <td>
                                                                {product.customer}
                                                            </td>

                                                        </tr>
                                                    )
                                                })
                                            }
                                            </tbody>
                                        </table>

                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default ProductTracking;